import React from "react";
import { View, Text } from "@react-pdf/renderer";
import style from "./style";

function PdfSummaryItem(props) {
  return (
    <View style={style.container}>
      <View style={style.snoContainer}>
        <Text style={style.snoText}>{props.sno}.</Text>
      </View>
      <Text style={style.questionText}>
        {props.question}:<Text style={style.answerText}> {props.answer}</Text>
      </Text>
    </View>
  );
}

export default PdfSummaryItem;
